interface ApiConstantsInterface {
  baseUrl: string
  getCustomerInfo: string
  postCustomerInfo: string
}

const apiConstants: ApiConstantsInterface = {
  baseUrl: '/api/customer/info',
  getCustomerInfo: `/`,
  postCustomerInfo: `/`,
}

export { apiConstants, ApiConstantsInterface }
